module.exports = __webpack_public_path__ + "img/19m.6dd8b18a.png";